var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticalText = function SvgVerticalText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.4393 19.2091H8.60809L13.9014 4.79089H15.704L20.9974 19.2091H19.1662L14.8587 7.07211H14.7468L10.4367 19.2091H10.4393ZM11.1156 13.5776H18.4951V15.1253H11.1156V13.5776ZM6.02515 5.44118V15.9759H7.42197C7.75752 15.9759 7.9396 16.3686 7.7211 16.6236L5.78845 18.9074C5.58816 19.1441 5.2266 19.1441 5.02631 18.9074L3.09365 16.6236C2.87775 16.3686 3.05983 15.9759 3.39278 15.9759H4.72197V5.44118C4.72457 5.08222 5.0159 4.79089 5.37486 4.79089 5.73382 4.79089 6.02515 5.08222 6.02515 5.44118Z"
  })));
};
export default SvgVerticalText;